import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gray-200 shadow-2xl">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
          <div className="flex items-start gap-3 md:gap-4 flex-1">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 md:w-6 md:h-6 text-amber-600" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1 md:mb-2">
                {t('cookieTitle')}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                {t('cookieText')}
              </p>
            </div>
          </div>

          <div className="flex flex-row gap-2 md:gap-3 w-full md:w-auto">
            <Button
              onClick={declineCookies}
              variant="outline"
              size="sm"
              className="border-2 border-gray-300 hover:bg-gray-50 flex-1 md:flex-none text-sm"
            >
              {t('cookieDecline')}
            </Button>
            <Button
              onClick={acceptCookies}
              size="sm"
              className="bg-sky-600 hover:bg-sky-700 text-white flex-1 md:flex-none text-sm"
            >
              {t('cookieAccept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
